import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../context/userContext";
import PageHead from "../component/PageHead";
import PostForm from "../component/PostForm";
import { authHeaders, CATEGORIES } from "../constants";

const CreatePost = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState(CATEGORIES[0]);
  const [description, setDescription] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { currentUser } = useContext(UserContext);
  const token = currentUser?.token;

  useEffect(() => {
    if (!token) navigate("/login");
  }, [token, navigate]);

  const createPost = async (e) => {
    e.preventDefault();
    const postData = new FormData();
    postData.set("title", title);
    postData.set("category", category);
    postData.set("description", description);
    postData.set("thumbnail", thumbnail);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/posts`,
        postData,
        authHeaders(token)
      );
      if (response.status === 201) navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "Couldn't publish the post.");
    }
  };

  return (
    <div className="container editor-page">
      <PageHead num="W" label="New post" line1="Write it down," line2="share what you know." />
      <PostForm
        {...{ title, setTitle, category, setCategory, description, setDescription, thumbnail, setThumbnail, error }}
        onSubmit={createPost}
        onCancel={() => navigate(-1)}
        submitLabel="Publish post"
      />
    </div>
  );
};

export default CreatePost;
